import type { Dayjs } from 'dayjs';
import type { Permission } from 'src/assets/data/permissions';

declare module 'react-oidc-context' {
  // Extends profile props, these come from Keycloak client scopes
  interface AuthContextProps {
    user: AuthState['user'] & {
      profile: {
        clientId: string;
        permissions: Permission[];
      };
    };
  }
}

export type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type IDateValue = string | number | null;

export type IDatePickerControl = Dayjs | null;

export type SortDirection = 'asc' | 'desc';

export type TableResponse<TData> = {
  rows: TData[];
  totalItems: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type TableDataResponse<TData> = {
  data: TData[];
  totalItems: number;
  limit: number;
  page: number;
  totalPages: number;
};

export type PaginatedResponse<TData> = {
  data: TData[];
  totalItems: number;
  limit: number;
  page: number;
  totalPages: number;
};

export type DataResponse<TData> = {
  data: TData;
  status: number;
};

export interface ISelectOption {
  key: string;
  value: string;
}

export enum ColorType {
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Success = 'success',
}

export type Languages = 'en' | 'se' | 'fr' | 'de';

export enum ErrorCode {
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  INTERNAL = 'INTERNAL',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
}

export enum ProductNames {
  Inio = 'Inio',
  I2C = 'I2C',
}
